import React, { useState } from 'react';
import Field from '../fields/Field';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { currencyDisplay, handleAxiosErrors } from '../../_utils';
import CheckoutDiscountItem from './CheckoutDiscountItem';
import { axiosRemoveAppliedDiscountCoupon } from '../../actions/checkoutActions';
import ReactLoading from 'react-loading';
import { event } from 'jquery';

const FORM_LABEL = {
    DiscountCode: getTranslation('FIELD.DISCOUNT_CODE'),
};

function CheckoutDiscountCode(props) {
    const {
        isLoading,
        formData,
        handleFormUpdate,
        handleFormSubmission,
        appliedDiscountCode,
        ProductDiscountItems,
        currencyDisplayCode,
        currencyFormat,
        locale,
        AppliedDiscountTotal,
        toggleLoading,
        AppliedDiscountCouponID = 0,
    } = props;

    const [inputValue, setInputValue] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);

    const handleBlur = async (e) => {
        await handleFormSubmission(e);
        setInputValue('');
    };

    const handleOnChange = (e) => {
        handleFormUpdate(e);
        setInputValue(e.target.value);
    }

    const handleEnterEvent = async (e) => {
        await handleFormSubmission(e);
        setInputValue('');
    }

    const handleRemoveAppliedDiscount = async (DiscountID) => {
        let payload = {
            ID: DiscountID
        }
        toggleLoading('removingCoupon', true);
        setIsDeleting(true);
        return axiosRemoveAppliedDiscountCoupon(payload)
            .then((response) => {
                setIsDeleting(false);

                props.requestDetails();
                props.requestCart();
                props.requestDeliveryOptions();

                toggleLoading('removingCoupon', false);
            })
            .catch((error) => {
                handleAxiosErrors(error);
                setIsDeleting(false);
                toggleLoading('removingCoupon', false);
            });
    }

    return (
        <React.Fragment>
            <div className='card__header'>
                <h5 className='heading--lv5 heading'>
                    <LocalizedMessage id={'CHECKOUT.DISCOUNT_CODE.HEADING'} />
                </h5>
            </div>
            <div className=''>
                <Field
                    isLoading={isLoading}
                    label={FORM_LABEL['DiscountCode']}
                    animatedLabel={FORM_LABEL['DiscountCode']}
                    name='DiscountCode'
                    value={inputValue}
                    onChange={handleOnChange}
                    disabled={window.currentOrderPaymentMethod ==
                        'order-card-authorization-payfast' &&
                        window.isEditOrder}
                    onBlur={handleBlur}
                    onEnter={handleEnterEvent}
                />
                {appliedDiscountCode && (
                    <div className='discount-box' key='order-discount'>
                        <div>
                            <div>
                                <span>Discount: </span>
                                <span className='underline'>{appliedDiscountCode}</span>
                                <span className='text-bold'> {'\u00A0'}- {currencyDisplay(AppliedDiscountTotal, currencyDisplayCode, currencyFormat, locale)}</span>
                            </div>
                        </div>
                        <div style={{ position: 'relative' }}>
                            {isDeleting ? (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='black'
                                    height={20}
                                    width={20}
                                />
                            ) : (
                                <span className="icon-close cursor-pointer" onClick={() => handleRemoveAppliedDiscount(AppliedDiscountCouponID)}></span>
                            )}
                        </div>
                    </div>
                )}
                {ProductDiscountItems?.map((item) => (

                    <CheckoutDiscountItem
                        {...props}
                        item={item}
                        currencyDisplayCode={currencyDisplayCode}
                        currencyFormat={currencyFormat}
                        locale={locale}
                    />

                ))}


            </div>
        </React.Fragment>
    );
}

export default CheckoutDiscountCode;
